import { createAction, props } from '@ngrx/store';
import { OAuthTokenEntity } from '../../entities/o-auth-token.entity';

const prefix = 'data/' + 'o_auth_token/';
export const OAuthTokenActionTypes = {
    Load: createAction(prefix + 'load'),
    UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<OAuthTokenEntity> }>()),
};
